import { AxiosPromise } from "axios";

import { FinanceReceiverOverview } from "@/modules/financeReceiver/types";
import { get } from "@/shared/api/apiInstance";

export default function getFinanceReceiverOverview(): AxiosPromise<FinanceReceiverOverview> {
  return get("overview");
}
